// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   Avatar,
//   Box,
//   Chip,
//   CircularProgress,
//   Alert,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
// } from "@mui/material";

// import { getSpotGoldApi } from "../../app/slices/spotGold/spotGoldSlice";

// export default function BatukProducts() {
//   const dispatch = useDispatch();
//   const { spotGold, loading, errors } = useSelector(
//     (state) => state.spotGoldSlice,
//   );
//   useEffect(() => {
//     dispatch(getSpotGoldApi());
//   }, [dispatch]);

//   const products = spotGold?.data?.data || [];

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" py={6}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (errors && errors.length > 0) {
//     return (
//       <Alert severity="error" sx={{ my: 2 }}>
//         {errors[errors.length - 1] || "Failed to load Batuk products."}
//       </Alert>
//     );
//   }

//   if (!products.length) {
//     return (
//       <Alert severity="info" sx={{ my: 2 }}>
//         No Batuk products found.
//       </Alert>
//     );
//   }

//   return (
//     <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
//       <Table>
//         <TableHead>
//           <TableRow>
//             <TableCell>Image</TableCell>
//             <TableCell>Product</TableCell>
//             <TableCell>Category / Subcategory</TableCell>
//             <TableCell align="right">Weight (g)</TableCell>
//             <TableCell align="right">Price</TableCell>
//             <TableCell align="center">Status</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {products.map((product) => {
//             const price = product?.productPrice?.[0]?.finalProductPrice ?? "-";
//             const categoryName =
//               product?.subCategory?.category?.categoryName || "-";
//             const subCategoryName =
//               product?.subCategory?.subCategoryName || "-";

//             return (
//               <TableRow key={product._id || product.id} hover>
//                 <TableCell>
//                   <Avatar
//                     variant="rounded"
//                     src={product.productImage}
//                     alt={product.productName}
//                     sx={{ width: 56, height: 56 }}
//                   />
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant="body2" fontWeight={500}>
//                     {product.productName}
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     SKU: {product.sku}
//                   </Typography>
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant="body2">{categoryName}</Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     {subCategoryName}
//                   </Typography>
//                 </TableCell>
//                 <TableCell align="right">{product.weight}</TableCell>
//                 <TableCell align="right">
//                   {typeof price === "number" ? `₹${price}` : price}
//                 </TableCell>
//                 <TableCell align="center">
//                   <Chip
//                     size="small"
//                     label={product.isActive ? "Active" : "Inactive"}
//                     color={product.isActive ? "success" : "default"}
//                     variant="outlined"
//                   />
//                 </TableCell>
//               </TableRow>
//             );
//           })}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// }
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  Stack,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

// Adjust this import path to match where your slice actually lives in the project.
import { getSpotGoldApi } from "../../app/slices/spotGold/spotGoldSlice";
import BatukForm from "./BatukForm";

export default function BatukProducts() {
  const dispatch = useDispatch();
  const { spotGold, loading, errors } = useSelector(
    (state) => state.spotGoldSlice,
  );

  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null); // null = "add" mode

  useEffect(() => {
    dispatch(getSpotGoldApi());
  }, [dispatch]);

  // API response shape: { data: { data: [...] }, error: false, message: "..." }
  // so the actual product array is nested at spotGold.data.data.
  const products = spotGold?.data?.data || [];

  const handleOpenAdd = () => {
    setEditingProduct(null);
    setDialogOpen(true);
  };

  const handleOpenEdit = (product) => {
    setEditingProduct(product);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setEditingProduct(null);
  };

  // Map a Batuk API product record onto the fields BatukForm understands.
  // Extend this once the real add/update API + fields are finalized.
  const formInitialData = editingProduct
    ? {
        name: editingProduct.productName || "",
        description:
          editingProduct.metaDescription || editingProduct.metaTitle || "",
        stock: editingProduct.weight > 0, // placeholder mapping until a real stock field exists
        status: !!editingProduct.isActive,
      }
    : undefined;

  const handleFormSubmit = (payload) => {
    // TODO: replace with the real create/update API calls once available.
    if (editingProduct) {
      console.log("Update Batuk product:", editingProduct._id, payload);
    } else {
      console.log("Create Batuk product:", payload);
    }
    handleCloseDialog();
  };

  const renderHeader = (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ mb: 2 }}
    >
      <Typography variant="h6" fontWeight={600}>
        Batuk Products
      </Typography>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleOpenAdd}
      >
        Add Product
      </Button>
    </Stack>
  );

  const renderDialog = (
    <Dialog
      open={dialogOpen}
      onClose={handleCloseDialog}
      maxWidth="sm"
      fullWidth
    >
      <IconButton
        onClick={handleCloseDialog}
        sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ p: 0 }}>
        <BatukForm
          key={editingProduct?._id || "new"}
          initialData={formInitialData}
          onSubmit={handleFormSubmit}
        />
      </DialogContent>
    </Dialog>
  );

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" py={6}>
        <CircularProgress />
      </Box>
    );
  }

  if (errors && errors.length > 0) {
    return (
      <Alert severity="error" sx={{ my: 2 }}>
        {errors[errors.length - 1] || "Failed to load Batuk products."}
      </Alert>
    );
  }

  if (spotGold?.error) {
    return (
      <Alert severity="error" sx={{ my: 2 }}>
        {spotGold.message || "Failed to load Batuk products."}
      </Alert>
    );
  }

  if (!products.length) {
    return (
      <Box>
        {renderHeader}
        <Alert severity="info" sx={{ my: 2 }}>
          No Batuk products found.
        </Alert>
        {renderDialog}
      </Box>
    );
  }

  return (
    <Box>
      {renderHeader}

      <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image</TableCell>
              <TableCell>Product</TableCell>
              <TableCell>Category / Subcategory</TableCell>
              <TableCell align="right">Weight (g)</TableCell>
              <TableCell align="right">Price</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {products.map((product) => {
              const price =
                product?.productPrice?.[0]?.finalProductPrice ?? "-";
              const categoryName =
                product?.subCategory?.category?.categoryName || "-";
              const subCategoryName =
                product?.subCategory?.subCategoryName || "-";

              return (
                <TableRow key={product._id || product.id} hover>
                  <TableCell>
                    <Avatar
                      variant="rounded"
                      src={product.productImage}
                      alt={product.productName}
                      sx={{ width: 56, height: 56 }}
                    />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" fontWeight={500}>
                      {product.productName}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      SKU: {product.sku}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">{categoryName}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {subCategoryName}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">{product.weight}</TableCell>
                  <TableCell align="right">
                    {typeof price === "number" ? `₹${price}` : price}
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      size="small"
                      label={product.isActive ? "Active" : "Inactive"}
                      color={product.isActive ? "success" : "default"}
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      onClick={() => handleOpenEdit(product)}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {renderDialog}
    </Box>
  );
}
